module.exports = __webpack_public_path__ + "b0ab5d4c355a7c89940157bea59baf3f.svg";